import {
  CreateOrderSheetOrderItemInput,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_first_order_discount,
  OrderPromotionType,
} from '../../graphql/select-option_types.2';

/**
 * 첫 주문 할인 정보를 추가합니다
 * @param order_item - 주문 아이템
 * @param first_order_discount - 첫 주문 할인 정보
 * @param context - 직진 옵션 및 매칭 상품 여부
 * @returns 첫 주문 할인 정보를 추가한 주문 아이템
 */
export const applyFirstOrderDiscount = (
  order_item: CreateOrderSheetOrderItemInput,
  first_order_discount: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_first_order_discount | null,
  context: { is_zigzin_option: boolean; is_zigzin_matching_product: boolean },
): CreateOrderSheetOrderItemInput => {
  const { is_zigzin_option, is_zigzin_matching_product } = context;

  // 첫 주문 할인 처리
  if (validateFirstOrderDiscount(first_order_discount, is_zigzin_matching_product, is_zigzin_option)) {
    order_item.promotion_applied_info = {
      promotion_applied_discount_price: first_order_discount?.price ?? 0,
      promotion_id: first_order_discount?.promotion_id ?? '',
      promotion_type: OrderPromotionType.FIRST_ORDER,
    };
  }

  return order_item;
};

/**
 * 첫 주문 할인 적용 가능 여부를 검증합니다
 * @param first_order_discount - 첫 주문 할인 정보
 * @param is_zigzin_matching_product - 직진 매칭 상품 여부
 * @param is_zigzin_option - 직진 옵션 여부
 * @returns 첫 주문 할인 적용 가능 여부
 */
const validateFirstOrderDiscount = (
  first_order_discount: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_first_order_discount | null,
  is_zigzin_matching_product: boolean,
  is_zigzin_option: boolean,
): boolean => {
  const is_first_order_discount = Boolean(first_order_discount?.promotion_id);
  const is_first_order_in_matching_product = is_zigzin_matching_product && is_zigzin_option && is_first_order_discount;
  const is_first_order_in_product = !is_zigzin_matching_product && is_first_order_discount;

  if (is_first_order_in_matching_product || is_first_order_in_product) {
    return true;
  }

  return false;
};
